import { Visibility } from "@mui/icons-material";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { useSnackbar } from "notistack";
import { useEffect, useState } from "react";
import DialogModal from "../../../../../atoms/dialog";
import CustomBtnFilled from "../../../../../atoms/form-molecules/CustomBtnFilled";
import FormCancelSubmitBtns from "../../../../../atoms/formCancelSubmitBtns";
import { APIRoutes } from "../../../../../constants";
import { handleCopy } from "../../../../../molecules/expert-profile-sections/profile-section/helper";
import { useFetch } from "../../../../../utils/hooks/useFetch";
import { useGetParams } from "../../../../../utils/hooks/useGetParams";
import { useHookFormContext } from "../../../../../utils/hooks/useHookFormContext";
import { getPeMappingSharedUrlWithoutToken } from "../../../../project-detail/mapping/helper";
import FormFields from "./fields/formFields";
import ProfileSection from "./fields/profileSection";
import Snippets from "./fields/snippets";
import { lineBreakStyle } from "./style";
import { FieldProps } from "./type";
import AgendaSelectionView from "../invite-expert/AgendaSelectionView";

const Fields = ({
  handleClose,
  expert_id,
  handleChange,
  designation,
  company,
  expertsData,
  location,
  isUsedInBulk,
  isBulkLast,
  group,
  ask_for_govt_employee,
  client_id,
  pe_id,
  archetypes,
  checkedAgendaIds,
  setCheckedAgendaIds,
  agendaResponseData
}: FieldProps) => {

  const [selectedAgendaId, setSelectedAgendaId] = useState<number | null>(null);
  const project_id = useGetParams("project_id");
  const { watch, getValues } = useHookFormContext();
  const { enqueueSnackbar } = useSnackbar();
  const [showAgendaPreview, setShowAgendaPreview] = useState(false);

  const snippetsData =
    expertsData?.snippets?.length !== 0
      ? expertsData.snippets.map((snip: any) => ({ ...snip }))
      : [];

  const handleAgendaCheck = (id: number) => {
    setCheckedAgendaIds((prev) =>
      prev.includes(id) ? prev.filter((i) => i !== id) : [...prev, id]
    );
  };

 

  useEffect(() => {
    const subscription = watch((value, { name, type }) => {
      if (type === "change") {
        handleChange();
      }
    });
    return () => subscription.unsubscribe();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [watch]);

  const onClickViewAgendaIcon = (id: number) => {
    setSelectedAgendaId(id)
    setShowAgendaPreview(true)
  }

  return (
    <Grid container overflow={"hidden"}>
      <Grid item xs={12} md={8} sx={{ position: "relative" }}>
        <Snippets expert_id={expert_id} snippetsData={snippetsData} />
      </Grid>
      <Grid item xs={12} sm={0.2} margin={{ xs: "1rem", sm: "0" }}>
        <Box sx={lineBreakStyle}></Box>
      </Grid>

      <Grid
        container
        item
        xs={12}
        md={3.8}
        sx={{
          display: "flex",
          alignItems: "flex-start",
          justifyContent: "flex-start",
        }}
      >
        <Grid container item xs={12}>
          <ProfileSection
            expertsData={expertsData}
            expert_id={expert_id}
            company={company}
            designation={designation}
            location={location}
          />
          <FormFields
            group={group}
            ask_for_govt_employee={!!ask_for_govt_employee}
            client_id={client_id}
            archetypes={archetypes}
            respondedAgendas={agendaResponseData}
            checkedAgendaIds={checkedAgendaIds}
            onClickViewAgendaIcon={(id) => onClickViewAgendaIcon(id)}
            handleAgendaCheck={(id) => handleAgendaCheck(id)}
          />

          {showAgendaPreview && (
            <DialogModal
              isOpen={showAgendaPreview}
              handleClose={() => setShowAgendaPreview(false)}
              title={"Agenda Preview"}
            >
              <AgendaSelectionView
                agendas={agendaResponseData}
                selectedAgendaId={selectedAgendaId}
                setSelectedAgendaId={setSelectedAgendaId}
              />
            </DialogModal>
          )}

          <Grid
            item
            xs={12}
            display={"flex"}
            alignItems={"flex-start"}
            justifyContent={"flex-start"}
            mb={"1rem"}
          >
            <CustomBtnFilled
              label="Copy Link"
              variant="outlined"
              onClick={() => {
                const previewUrl = getPeMappingSharedUrlWithoutToken(
                  project_id,
                  client_id,
                  String(expert_id),
                );
                handleCopy(previewUrl, enqueueSnackbar, "Link");
              }}
              styles={{ width: "100%", fontWeight: "400", marginTop: "7px" }}
            />
          </Grid>
          <Grid item xs={12}>
            <FormCancelSubmitBtns
              cancelLabel={isUsedInBulk ? "Skip" : "Cancel"}
              handleClose={handleClose}
              submitLabel={
                isUsedInBulk ? (isBulkLast ? "Share" : "Share & Next") : "Share"
              }
            />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};
export default Fields;